import React from 'react';
import { Badge } from 'react-bootstrap';
import { ModashHealthStatusEnum } from '../../../enum/ModashHealthStatusEnum';

export function ModashStatusBadge({ status }: { status?: ModashHealthStatusEnum }) {
    switch (status) {
        case ModashHealthStatusEnum.HEALTHY:
            return <Badge bg="primary">Healthy</Badge>;
        case ModashHealthStatusEnum.DEGRADED:
            return (
                <Badge bg="warning" text="dark">
                    Degraded
                </Badge>
            );
        default:
            return <Badge bg="danger">Unhealthy</Badge>;
    }
}
